import { REGULAR_VARIANT } from '../../constants';

export const DEFAULT_VARIANT = REGULAR_VARIANT;
